import { ADD_LEAGUES } from "../constants/leagueConstants";

export const addLeagues = leagues => ({
  type: ADD_LEAGUES,
  payload: leagues
});
